var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 140,
    height: 140,
    rx: 70,
    fill: "#E2FEF1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 140,
    height: 140,
    rx: 70,
    stroke: "#F2FEF5",
    strokeWidth: 9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.0001 110.833C94.7084 110.833 110.833 94.7082 110.833 74.9998C110.833 55.2915 94.7084 39.1665 75.0001 39.1665C55.2917 39.1665 39.1667 55.2915 39.1667 74.9998C39.1667 94.7082 55.2917 110.833 75.0001 110.833Z",
    stroke: "#2BA865",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7708 75.0002L69.9116 85.141L90.2291 64.8594",
    stroke: "#2BA865",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/SuccessIcon.4d65db9536e3ee4d5a14995c799aa183.svg";
export { ForwardRef as ReactComponent };